(function() {
  "use strict";

  angular.module("atcCallSign").config(config);

  function config($stateProvider) {
    $stateProvider.state("atcCallSign", {
      url: "/atc-call-sign",
      views: {
        atcCallSignView: {
          templateUrl: "atc-call-sign/views/atc-call-sign.tpl.html",
          controller: "AtcCallSignCtrl",
          controllerAs: "atcCallSign"
        }
      }
    });
  }
})();
